

<template>
  <div class="nav-wrapper" v-show="scrollTop == 0" @mouseenter="navHover = true" @mouseleave="navHover = false" :style="{background: navHover?'#f5f5f5':'transparent'}">
    <div class="nav-content">
      <div class="nav-logo"><img class="logo" src="../../../assets/logo.png"/></div>
      <ul>
        <li @click="goPage('Index')">
          <span :class="{'active': activeRoute === 'Index'}">首页</span>
        </li>
        <li @mouseenter="aboutMenuShow = true" @mouseleave="aboutMenuShow = false"  @click="goPage('Story')">
          <span :class="{'active': activeRoute === 'Story'}">关于雅致</span>
<!--          <div class="drop-down">-->
<!--            <Transition name="aboutBox">-->
<!--              <div  class="drop-down-box about-drop-down"   v-show="aboutMenuShow">-->
<!--                <div  class="left-nav">-->
<!--                  <div v-for="(item,itemInd) in aboutTabs" @click.stop="goPage(item.route)" :key=itemInd>-->
<!--                    {{item.name}}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div  class="right-intro">-->
<!--                  <div class="intro-img">-->
<!--                    <img  src="../../../assets/image/about.jpg"/>-->
<!--                  </div>-->
<!--                  <div class="intro-content">-->
<!--                    <h3>专业家用产后修复品牌</h3>-->
<!--                    <div class="text">-->
<!--                      <p>雅致医疗前身为医院大器械供货商，拥有全国领先的产后修复医疗器械研发技术。</p>-->
<!--                      <p>在大型治疗设备的基础上创新治疗场景，让患者居家即可完成产后相关评估与治疗康复。</p>-->
<!--                      <p>雅致医疗致力于成为一家集家用医疗器械研发、生产、销售及互联网信息医疗服务为一体的产后修复第一品牌。</p>-->
<!--                    </div>-->
<!--                    <div class="about-more">了解更多</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </Transition>-->
<!--          </div>-->
        </li>
        <li  @mouseenter="instrumentMoreShow()" @mouseleave="instrumentMenuShow = false"  @click="goPage('InstrumentMore')">
          <span  :class="{'active': activeRoute === 'InstrumentIndex' ||  activeRoute === 'InstrumentMore'}">盆底肌修复仪</span>
          <div class="drop-down">
            <Transition name="instruBox">
              <div class="drop-down-box instrument-drop-down"  v-show="instrumentMenuShow">
                <img src="../../../assets/image/intru.png"/>
                <div class="name">雅致盆底肌修复仪</div>
                <div class="about-more"   @click.stop="goPage('InstrumentMore')">了解更多</div>
              </div>
            </Transition>
          </div>
        </li>
        <li  @click="goPage('ServiceCenter')">
          <span  :class="{'active': activeRoute === 'ServiceCenter'}">服务中心</span>
        </li>
        <li style="position: relative"  @mouseenter="buyMenuShow = true" @mouseleave="buyMenuShow = false" @click="goPage('buy')">
          <span :class="{'active': activeRoute === 'buy'}">立即购买</span>
          <div class="mini-drop-down" v-show="buyMenuShow">
            <div></div>
            <div @click.stop="goLink('tm')">天猫旗舰店</div>
            <div  @click.stop="goLink('jd')">京东旗舰店</div>
            <div  @click.stop="goLink('dy')">抖音旗舰店</div>
            <div  @click.stop="goLink('hs')">小红书旗舰店</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: "TopNav",
  data() {
    return {
      navHover: false,
      aboutMenuShow: false,
      instrumentMenuShow: false,
      buyMenuShow: false,
      scrollTop: 0,
      activeRoute: 'Index',
      aboutTabs: [{name:"关于雅致",route:'Story'},{name:"雅致资讯",route:'News'}],
      shopLink: [
        {code: 'tm',link: 'https://detail.tmall.com/item.htm?id=759819355376'},
        {code: 'jd',link: 'https://item.jd.com/10099773768137.html'},
        {code: 'dy',link: 'https://haohuo.jinritemai.com/ecommerce/trade/detail/index.html?id=3688275873254998316&origin_type=604'},
        {code: 'hs',link: 'https://www.xiaohongshu.com/goods-detail/66052a9a5c3c5a000145c6a5?xhsshare=CopyLink&appuid=5c37034e000000000700a4c9&apptime=1716456882'},
      ]
      // aboutTabs: [{name:"关于雅致",route:'About'},{name:"品牌故事",route:'Story'},{name:"雅致资讯",route:'News'},{name:"品牌实力",route:''}],
    }
  },
  mounted() {
    this.activeRoute = sessionStorage.getItem('activeNav') || 'Index'
    window.addEventListener('scroll',() => {
      const st = document.documentElement.scrollTop || document.body.scrollTop
      this.scrollTop = st
      this.navHover = st> 0
    })
  },
  methods: {
    instrumentMoreShow(){
      this.instrumentMenuShow = this.activeRoute !== 'InstrumentMore'
    },
    goPage(route){
      sessionStorage.setItem('activeNav', route)
      this.$router.push('/'+route)
    },
    hoverLeave() {
      const st = document.documentElement.scrollTop
      this.navHover = st> 0
    },
    goLink(code){
      const shop = this.shopLink.filter((item) => item.code === code)
      if(shop.length> 0) {
        window.open(shop[0].link)
      }
    },
  }
}
</script>
<style lang="less"  scoped>
.nav-wrapper {
  left: 50%;
  z-index: 10;
  transform: translate(-50%,0);
  font-size: 16px;
  padding-top: 36px;
  position: fixed;
  top: 0;
  width: 100%;
  .aboutBox-leave-active,
  .aboutBox-enter-active,.instruBox-leave-active,
  .instruBox-enter-active {
    transition: all 1s ease;
  }
  .aboutBox-leave-to,.aboutBox-enter,.instruBox-leave-to,.instruBox-enter {
    height: 0 !important;
    opacity: 0;
  }
  .aboutBox-enter-to,.aboutBox-leave{
    height: 300px;
    opacity: 1;
  }
  .instruBox-enter-to,.instruBox-leave{
    height: 210px;
    opacity: 1;
  }
  .nav-content {
    width: 50%;
    margin: 0 auto;
    max-width: 1024px;
    min-width: 800px;
  }
  .nav-logo {
    text-align: center;
    img {
      margin: 0 auto;
    }
  }
  ul {
    display: flex;
    flex-direction: row;
    list-style: none;
    justify-content: center;
    li {
      padding: 5px 30px;
      span {
        cursor: pointer;
      }
      .active{
        color: #D2B08C;
      }
      .drop-down {
        position: absolute;
        top: 130px;
        width: 100%;
        left: 0;
        z-index: 9;
      }
      .about-more {
        color: #ffffff;
        border-radius: 50px;
        display: inline-block;
        font-size: 15px;
        padding: 10px 0;
        width: 120px;
        text-align: center;
        background: linear-gradient(to right,#DDC4A9,#D2B08C);
        flex: 0 0 auto;
        cursor: pointer;
      }
      .drop-down-box {
        width: 100%;
        margin: 0 auto;
        background: #f5f5f5;
      }
      .about-drop-down {
        display: flex;
        flex-direction: row;
        height: 320px;
        justify-content: center;
        padding: 60px 0 40px;
        .left-nav {
          flex: 0 0 100px;
          max-width: 110px;
          div {
            margin-bottom: 50px;
            cursor: pointer;
            font-size: 18px;
          }
        }
        .right-intro {
          flex: 1 1 auto;
          max-width: 1000px;
          display: flex!important;
          flex-direction: row;
          .intro-content{
            width: 450px;
            line-height: 25px;
            display: flex;
            flex-direction: column;
            h3 {
              margin-top: 0;
              font-size: 20px;
              flex: 0 0 auto;
            }
            .text {
              flex: 1 1 auto;
            }
          }
          .intro-img {
            height: 320px;
            width: 330px;
            border-radius: 20px;
            overflow: hidden;
            margin: 0 30px 0 80px;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 20px;
            }
          }
        }
      }
      .instrument-drop-down {
        text-align: center;
        padding: 60px 0 30px;
        img {
          width: 70px;
        }
        .name {
          margin: 20px 0;
          color: #646464;
        }
        .more {
          color: #ffffff;
          border-radius: 50px;
          background: #AAAAAA;
          padding: 8px 35px;
          display: inline-block;
          cursor: pointer;
        }
      }
      .mini-drop-down {
        height: 230px;
        background: #ffffff;
        position: absolute;
        top: -10px;
        z-index: -1;
        width: 140px;
        left: 0;
        >div {
          height: 46px;
          line-height: 46px;
          text-align: center;
          cursor: pointer;
        }
        >div:hover{
          background: #F4EADF;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/new/components/TopNav.vue